// Reports: how the summary numbers are shown, and the query it is asked with.

export const WEEKLY_FORMATS = ['xlsx', 'csv'];

// The statuses in the order the server returns them.
export const REPORT_STATUS_ORDER = [
  'NEW',
  'PIC_NOTIFIED',
  'IN_PROGRESS',
  'AWAITING_SLOT',
  'SCHEDULED',
  'RESOLVED',
  'CLOSED',
  'REOPENED',
  'NEEDS_ADMIN',
];

// `reopen_rate.rate` is a fraction 0..1, or null when nothing was resolved.
export const formatRate = rate =>
  rate === null || rate === undefined ? null : `${Math.round(rate * 100)}%`;

// A figure that may be null (nothing to average): null stays null so the
// page can say "n/a" in its own words.
export const formatDays = days =>
  days === null || days === undefined ? null : String(days);

// The query for the summary: only what is set, dates as the server names them.
export function summaryQuery({ from, to, siteId, category, memberId }) {
  const query = {};
  if (from) query.from = from;
  if (to) query.to = to;
  if (siteId) query.site_id = siteId;
  if (category) query.category = category;
  if (memberId) query.member_id = memberId;
  return query;
}

export const isRangeInvalid = (from, to) => !!from && !!to && to < from;

const pad = n => String(n).padStart(2, '0');
const isoDay = date =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

// The Monday of the week holding `value` ("YYYY-MM-DD", or today when empty):
// the weekly file is named after it, and the server snaps to it the same way.
export function mondayOf(value, today = new Date()) {
  const date = value ? new Date(`${value}T00:00:00`) : new Date(today);
  const sinceMonday = (date.getDay() + 6) % 7;
  date.setDate(date.getDate() - sinceMonday);
  return isoDay(date);
}

// What the backend would have called the file (the proxy drops the name).
export const weeklyFileName = (weekStart, format) =>
  `weekly-ticket-summary-${mondayOf(weekStart)}.${format}`;
